// extracted by mini-css-extract-plugin
export default {"container":"Sidebar__container___ZOqZT","itemCount":"Sidebar__itemCount___hxBM3","dot":"Sidebar__dot___OW8bS","skeleton-loading":"Sidebar__skeleton-loading___y1Mo7"};